import { getChinaAndroidTrialProductId } from '@forest/paywall-core'
import { platform } from '~/lib/params'
import { api } from '~/services/api'
import { $chinaAndroidTrialEligibility, $serviceLevelStatus } from '~/store'
import type { OwnPurchaseStatsResponse, ServiceLevelStatus } from '~/types'

const CHINA_ANDROID_TRIAL_PRODUCT_ID = getChinaAndroidTrialProductId(
  import.meta.env.MODE,
)

export async function getRemoteStates(userId: number): Promise<{
  serviceLevelStatus: ServiceLevelStatus
  chinaAndroidTrialEligibility: 'unavailable' | 'available'
}> {
  if (import.meta.env.DEV) {
    $chinaAndroidTrialEligibility.set('unavailable')
    $serviceLevelStatus.set({ service_level: 'premium_signup' })
    return {
      serviceLevelStatus: { service_level: 'premium_signup' },
      chinaAndroidTrialEligibility: 'unavailable',
    }
  }

  const taskGetServiceLevelStatus = api.service
    .get(`user/users/${userId}/service-levels/status`)
    .json<ServiceLevelStatus>()

  let taskGetChinaAndroidTrialEligibility: Promise<'unavailable' | 'available'>
  if (platform === 'china_android' && CHINA_ANDROID_TRIAL_PRODUCT_ID) {
    taskGetChinaAndroidTrialEligibility = api.service
      .get(
        `store/users/${userId}/product/${CHINA_ANDROID_TRIAL_PRODUCT_ID}/own-purchase-stats`,
      )
      .json<OwnPurchaseStatsResponse>()
      .then(({ stats }) => {
        return stats.total_count > 0 ? 'unavailable' : 'available'
      })
  } else {
    taskGetChinaAndroidTrialEligibility = Promise.resolve('unavailable')
  }

  const [serviceLevelStatus, chinaAndroidTrialEligibility] = await Promise.all([
    taskGetServiceLevelStatus,
    taskGetChinaAndroidTrialEligibility,
  ])
  $serviceLevelStatus.set(serviceLevelStatus)
  $chinaAndroidTrialEligibility.set(chinaAndroidTrialEligibility)

  return {
    serviceLevelStatus,
    chinaAndroidTrialEligibility,
  }
}
